import React from 'react';
import { NavLink } from 'react-router-dom';
import { menuData } from './MenuData';
import Button from './Button';

import styles from './Navigation.module.css';

const Menu = ({ role, setRole, navBurger }) => {
    const data = menuData[role] || menuData.public;

    return (
        <div className={styles.menu}>
            {data.map((data) => (
                <li style={{ listStyle: "none" }} key={data.path}>
                    <NavLink to={data.path} className={styles.option}>
                        <img src={data.icon} alt='' className={styles.icon} />
                        <span className={styles.label}>{data.label}</span>
                    </NavLink>
                </li>
            ))}
            {navBurger &&
                <div className={styles.menuBtn}>
                    <Button role={role} setRole={setRole} />
                </div>
            }
        </div>
    );
};

export default Menu;